import { Image, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { isEmbeddedMode } from '../../auth/embedMode';
import { ROUTE_PATHS } from '../../routes/routePaths';
import { useProfileMenu, useUserAccess } from '../../services/userAccess';
import { coldFusionUrl, dataUsageReportUrl } from '../../util/constants';
import { requestParentManageAlerts } from '../../util/parentShell';
import { captureEventInternal } from '../../util/posthog';
import LogoutModal from '../Modals/LogoutModal';

const handleTopNavigationClick = (text: string): void => {
  void captureEventInternal('top_navigation_click', { text });
};

const handleAccountDropdownClick = (text: string): void => {
  void captureEventInternal('account_dropdown_click', { text });
};

const getAdminLoginUrl = (): string => {
  return coldFusionUrl || '';
};

interface UserNavbarProps {
  user?: {
    userEmail: string;
  };
}

export const UserNavbar: React.FC<UserNavbarProps> = ({ user }) => {
  const { data: userAccess } = useUserAccess();
  const { data: userProfile } = useProfileMenu();

  return (
    <div className="ms-auto d-flex align-items-center">
      <ul className="navbar-nav d-none d-lg-flex">
        <li className="nav-item">
          <Link
            to="/category-home-page"
            className="nav-link active"
            onClick={() => handleTopNavigationClick('Home')}
          >
            Home
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="#"
            className="nav-link"
            onClick={(event) => {
              event.preventDefault();
              handleTopNavigationClick('Support');
              window.open('https://form.jotformeu.com/80294509784366', '_blank','noopener,noreferrer,height=980,width=880');
            }}
          >
            Support
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="https://www.aosphere.com"
            className="nav-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleTopNavigationClick('More Services')}
          >
            More Services
          </Link>
        </li>
      </ul>
      <div className="ao_userDrop dropdown">
        <NavDropdown
          title={
            <Image
              src="/assets/images/newdesign/head_user.svg"
              alt="User Profile"
              roundedCircle
            />
          }
          id="userDropdown"
          align="end"
        >
          <NavDropdown.Item disabled id="user-email">
            {user?.userEmail}
          </NavDropdown.Item>

          {userProfile?.changePassword && (
          <NavDropdown.Item
            as={Link}
            to={ROUTE_PATHS.CHANGE_PASSWORD}
            id="change-password-link"
            onClick={() => handleAccountDropdownClick('Change Password')}
          >
            Change Password
          </NavDropdown.Item>
          )}

          <NavDropdown.Item
            as={Link}
            to={ROUTE_PATHS.MY_ALERT}
            id="my-alerts-link"
            onClick={(event) => {
              handleAccountDropdownClick('My Alerts');
              if (isEmbeddedMode() && requestParentManageAlerts()) {
                event.preventDefault();
              }
            }}
          >
            My Alerts
          </NavDropdown.Item>
          <NavDropdown.Divider />

          {userAccess?.adminAccess && (
            <NavDropdown.Item
              as={Link}
              to={getAdminLoginUrl()}
              id="admin-login-link"
              onClick={() => handleAccountDropdownClick('Admin Login')}
            >
              Admin Login
            </NavDropdown.Item>
          )}

          {userProfile?.userUsageReportAccess && (
            <NavDropdown.Item
              as={Link}
              to={dataUsageReportUrl ?? ''}
              target="_blank"
              id="usage-reports-link"
              onClick={() => handleAccountDropdownClick('Usage Reports')}
            >
              Usage Reports
            </NavDropdown.Item>
          )}
          <LogoutModal onItemClick={() => handleAccountDropdownClick('Logout')} />
        </NavDropdown>
      </div>
    </div>

    // <>
    //   <Navbar expand="lg" className="navbar-nav d-none d-lg-flex">
    //     <Nav className="nav-item">
    //       <Nav.Link as={Link} to="/category-home-page" active>
    //         Home
    //       </Nav.Link>
    //     </Nav>
    //     <Nav className="nav-item">
    //       <Nav.Link as={Link} to="#">
    //         Support
    //       </Nav.Link>
    //     </Nav>
    //     <Nav className="nav-item">
    //       <Nav.Link
    //         href="https://www.aosphere.com"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //       >
    //         More Services
    //       </Nav.Link>
    //     </Nav>
    //   </Navbar>
    //   <div className="ao_userDrop me-3 dropdown">
    //     <NavDropdown
    //       title={
    //         <Image
    //           src="https://www.aoslogindev.com/aoslogindev/images/newdesign/head_user.svg"
    //           alt="User Profile"
    //           roundedCircle
    //           style={{ width: 32, height: 32 }}
    //         />
    //       }
    //       id="userDropdown"
    //       align="end"
    //     >
    //       <NavDropdown.Item disabled>{user?.email}</NavDropdown.Item>
    //       <NavDropdown.Item as={Link} to="#">
    //         Change Password
    //       </NavDropdown.Item>
    //       <NavDropdown.Item as={Link} to="#">
    //         My Alerts
    //       </NavDropdown.Item>
    //       <NavDropdown.Divider />
    //       <NavDropdown.Item as="button" onClick={handleLogout}>
    //         Logout
    //       </NavDropdown.Item>
    //     </NavDropdown>
    //   </div>
    // </>
  );
};
